import React from "react";

import {
  Settings,
  People,
  FiberDvr,
  Dvr,
  LinkedCamera,
  SettingsInputAntenna,
  ViewWeek
} from "@material-ui/icons";
import SideBarMonitoring from "../assets/SideBarMonitoring.png";
import setting from "../assets/setting.png";
import HomePage from "../Home/Home";
import Users from "../Users/Users";
import Customers from "../Customers/Customer";
import Contacts from "../Contacts/contact";
import Campaign from "../Campaign/Campaign";
import Leads from "../Leads/Leads";
import SystemSettings from "../SystemSettings/SystemSettings";
import Monitoring from "../Monitoring/Campaign";

export const routeConfig = [
  {
    title: "Home",
    path: "/",
    pageHeader: "Home",
    exact: true,
    icon: <Settings />,
    main: () => <HomePage />,
    customClass: "systemSetupIcon"
  },
  {
    title: "Users",
    path: "/Users",
    pageHeader: "User Management",
    exact: true,
    icon: <People />,
    main: () => <Users />,
    customClass: "clientsIcon"
  },
  {
    title: "Customers",
    path: "/Customers",
    pageHeader: "Customer Management",
    exact: true,
    icon: <SettingsInputAntenna />,
    main: () => <Customers />,
    customClass: "siteTypeIcon"
  },
  {
    title: "Campaigns",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  {
    title: "ABM",
    path: "/ABM",
    pageHeader: "Contacts",
    exact: true,
    icon: <FiberDvr />,
    main: () => <Contacts />,
    customClass: "dvrSetup"
  },
  // {
  //   title: "Contacts",
  //   path: "/contacts",
  //   pageHeader: "Contacts",
  //   exact: true,
  //   icon: <FiberDvr />,
  //   main: () => <Contacts />,
  //   customClass: "dvrSetup"
  // },
  {
    title: "Leads",
    path: "/leads",
    pageHeader: "Leads Management",
    exact: true,
    icon: <LinkedCamera />,
    main: () => <Leads />,
    customClass: "cameraSetupIcon"
  },

  {
    title: "Monitoring",
    path: "/Monitoring",
    pageHeader: "Monitor Management",
    exact: true,
    icon: <SideBarMonitoring />,
    main: () => <Monitoring />,
    customClass: "MonitoringSetupIcon"
  },
  {
    title: (
      <img
        src={setting}
        alt="Setting"
        className="deleteButton"
        title="Settings"
      />
    ),
    path: "/setting",
    pageHeader: "System Settings",
    exact: true,
    // icon: (
    //   <img
    //     src={setting}
    //     alt="Delete"
    //     className="deleteButton"
    //     title="Sign Out"
    //   />
    // ),
    icon: <setting />,
    main: () => <SystemSettings />,
    customClass: "panelMgmtIcon"
  }
];

export const routeAdmin = [
  {
    title: "Home",
    path: "/",
    pageHeader: "Home",
    exact: true,
    icon: <Settings />,
    main: () => <HomePage />,
    customClass: "systemSetupIcon"
  },
  {
    title: "Users",
    path: "/Users",
    pageHeader: "User Management",
    exact: true,
    icon: <People />,
    main: () => <Users />,
    customClass: "clientsIcon"
  },
  {
    title: "Customers",
    path: "/Customers",
    pageHeader: "Customer Management",
    exact: true,
    icon: <SettingsInputAntenna />,
    main: () => <Customers />,
    customClass: "siteTypeIcon"
  },
  {
    title: "Campaigns",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  // {
  //   title: "ABM",
  //   path: "/ABM",
  //   pageHeader: "Contacts",
  //   exact: true,
  //   icon: <FiberDvr />,
  //   main: () => <Contacts />,
  //   customClass: "dvrSetup"
  // },

  {
    title: "Leads",
    path: "/leads",
    pageHeader: "Leads Management",
    exact: true,
    icon: <LinkedCamera />,
    main: () => <Leads />,
    customClass: "cameraSetupIcon"
  }
];
export const routeAdmin2 = [
  {
    title: "Home",
    path: "/",
    pageHeader: "Home",
    exact: true,
    icon: <Settings />,
    main: () => <HomePage />,
    customClass: "systemSetupIcon"
  },
  {
    title: "Users",
    path: "/Users",
    pageHeader: "User Management",
    exact: true,
    icon: <People />,
    main: () => <Users />,
    customClass: "clientsIcon"
  },
  {
    title: "Customers",
    path: "/Customers",
    pageHeader: "Customer Management",
    exact: true,
    icon: <SettingsInputAntenna />,
    main: () => <Customers />,
    customClass: "siteTypeIcon"
  },
  {
    title: "Campaigns",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  {
    title: "ABM",
    path: "/ABM",
    pageHeader: "Contacts",
    exact: true,
    icon: <FiberDvr />,
    main: () => <Contacts />,
    customClass: "dvrSetup"
  },

  {
    title: "Leads",
    path: "/leads",
    pageHeader: "Leads Management",
    exact: true,
    icon: <LinkedCamera />,
    main: () => <Leads />,
    customClass: "cameraSetupIcon"
  }
];
export const routeCustomer = [
  {
    title: "Home",
    path: "/",
    pageHeader: "Home",
    exact: true,
    icon: <Settings />,
    main: () => <HomePage />,
    customClass: "systemSetupIcon"
  },

  {
    title: "Campaigns",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  // {
  //   title: "ABM",
  //   path: "/ABM",
  //   pageHeader: "Contacts",
  //   exact: true,
  //   icon: <FiberDvr />,
  //   main: () => <Contacts />,
  //   customClass: "dvrSetup"
  // },
  {
    title: "Leads",
    path: "/leads",
    pageHeader: "Leads Management",
    exact: true,
    icon: <LinkedCamera />,
    main: () => <Leads />,
    customClass: "cameraSetupIcon"
  }
];
export const routeCustomer2 = [
  {
    title: "Home",
    path: "/",
    pageHeader: "Home",
    exact: true,
    icon: <Settings />,
    main: () => <HomePage />,
    customClass: "systemSetupIcon"
  },

  {
    title: "Campaigns",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  {
    title: "ABM",
    path: "/ABM",
    pageHeader: "Contacts",
    exact: true,
    icon: <FiberDvr />,
    main: () => <Contacts />,
    customClass: "dvrSetup"
  },
  {
    title: "Leads",
    path: "/leads",
    pageHeader: "Leads Management",
    exact: true,
    icon: <LinkedCamera />,
    main: () => <Leads />,
    customClass: "cameraSetupIcon"
  }
];
export const routeCampaign = [
  {
    title: "Home",
    path: "/",
    pageHeader: "Home",
    exact: true,
    icon: <Settings />,
    main: () => <HomePage />,
    customClass: "systemSetupIcon"
  },

  {
    title: "Campaigns",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  // {
  //   title: "ABM",
  //   path: "/ABM",
  //   pageHeader: "Contacts",
  //   exact: true,
  //   icon: <FiberDvr />,
  //   main: () => <Contacts />,
  //   customClass: "dvrSetup"
  // },
  {
    title: "Leads",
    path: "/leads",
    pageHeader: "Leads Management",
    exact: true,
    icon: <LinkedCamera />,
    main: () => <Leads />,
    customClass: "cameraSetupIcon"
  }
];
export const routeCampaign2 = [
  {
    title: "Home",
    path: "/",
    pageHeader: "Home",
    exact: true,
    icon: <Settings />,
    main: () => <HomePage />,
    customClass: "systemSetupIcon"
  },

  {
    title: "Campaigns",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  {
    title: "ABM",
    path: "/ABM",
    pageHeader: "Contacts",
    exact: true,
    icon: <FiberDvr />,
    main: () => <Contacts />,
    customClass: "dvrSetup"
  },
  {
    title: "Leads",
    path: "/leads",
    pageHeader: "Leads Management",
    exact: true,
    icon: <LinkedCamera />,
    main: () => <Leads />,
    customClass: "cameraSetupIcon"
  }
];
export const DashboardPath2 = [
  {
    title: "CAMPAIGNS",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  }
];
export const DashboardPath = [
  {
    title: "CAMPAIGNS",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  {
    title: "CONNECT RATE",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  {
    title: "% ENGAGED",
    path: "/campaigns",
    pageHeader: "Campaign Management",
    exact: true,
    icon: <Dvr />,
    main: () => <Campaign />,
    customClass: "DvrModalIcon"
  },
  {
    title: "% LEADS",
    path: "/leads",
    pageHeader: "Leads Management",
    exact: true,
    icon: <LinkedCamera />,
    main: () => <Leads />,
    customClass: "cameraSetupIcon"
  }
];
